'use strict';

function formatTime(totalSeconds) {
  var hours = (totalSeconds - totalSeconds % 3600) / 3600,
      minutes = (totalSeconds - totalSeconds % 60 - hours * 3600) / 60,
      seconds = Math.round(totalSeconds % 60);

  return (hours > 0) ?
    hours + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2) :
    minutes + ':' + ('0' + seconds).slice(-2);
}

module.exports = formatTime;


/** WEBPACK FOOTER **
 ** ./utils/formatTime.js
 **/